// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qtAv","largestCol":"styles_largestCol__XQvFt","smallestCol":"styles_smallestCol__3O1Wt"};